import React from "react";
import { PageHeader } from "./PageHeader";

export const OrganizingCommittee = props => {
  var ulSize = {
    fontSize: '18px'
  };
  return (
    <React.Fragment>
      <PageHeader title="Komitety" />
      <div className="content-wrapper">
        <div className="main-content program">
          
          <h2>Lokalny Komitet Organizacyjny</h2>
          <ul style={ulSize}>
            <li>Dr hab. Roman Skibiński, Uniwersytet Jagielloński - <i>Przewodniczący Komitetu Organizacyjnego</i></li>
            <li>Dr inż. Marcin Zieliński, Uniwersytet Jagielloński - <i>Sekretarz Komitetu Organizacyjnego</i></li>
            <li>Dr Danuta Goc-Jagło, Uniwersytet Jagielloński - <i>Skarbnik</i></li>
            <li>Dr Kamil Awsiuk, Uniwersytet Jagielloński</li>
            <li>Prof. dr hab. Zdzisław Burda, Akademia Górniczo-Hutnicza</li>
            <li>Dr hab. Krzysztof Dzierżęga, prof. UJ, Uniwersytet Jagielloński</li>
            <li>Dr inż. Maciej Fidrysiak, Uniwersytet Jagielloński</li>
            <li>Dr Szymon Godlewski, Uniwersytet Jagielloński</li>
            <li>Dr hab. Andrzej Kapanowski, Uniwersytet Jagielloński</li>
            <li>Dr hab. Andrzej Odrzywołek, Uniwersytet Jagielloński</li>
            <li>Dr Marcin Misiaszek, Uniwersytet Jagielloński</li>
            <li>Dr Kacper Topolnicki, Uniwersytet Jagielloński</li>
            <li>Prof. dr hab. Roman Płaneta, Uniwersytet Jagielloński</li>
            <li>Prof. dr hab. Piotr Zieliński, Instytut Fizyki Jądrowej im. Prof. H.Niewodniczańskiego Polskiej Akademii Nauk</li>
          </ul>
          <h2>Komitet Organizacyjny Konferencji Dydaktycznej</h2>
          <ul style={ulSize}>
            <li>Dr Witold Zawadzki, Uniwersytet Jagielloński - Przewodniczący Komitetu Organizacyjnego Konferencji Dydaktycznej</li>
            <li>Mgr Irena Smoter, Zespół Szkół w Wolbromiu</li>
            <li>Dr Dagmara Sokołowska, Uniwersytet Jagielloński</li>
            <li>Dr Łukasz Stępień, Uniwersytet Pedagogiczny</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

OrganizingCommittee.propTypes = {};
